require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-gattendorf.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-gattendorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-gattendorf!./.cache/json/betreuungseinrichtungen-neusiedl-gattendorf.json
// module id = 949
// module chunks = 231608221292675